module.exports = __webpack_public_path__ + "img/SERVICE.17fda526.svg";